import { Injectable } from '@angular/core';
import mixpanel, { Dict } from 'mixpanel-browser';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  constructor() {
    mixpanel.init('b86c08d5f0dea04b94db72e263bf002f');
  }

  public track(type: string, props?: Dict) {
    mixpanel.track(type, props);
  }


}
